import { GetClientFlags200Response, SubscriptionDetails } from "@coeff/api";
import React, { useContext } from "react";

import { Button } from "../../../components";
import { COLORS } from "../../../constants";
import { ableToSelfCancel } from "../../../utils/selfServeCancellationEligibility";
import { BillingContext } from "../Billing";

type Props = {
  subscriptionDetails?: SubscriptionDetails | null;
  clientFlags?: GetClientFlags200Response | null;
  userEmail: string;
  featureEnabled?: boolean;
  /** Tighter fine-print copy ("To cancel instead, …") used by the downgrade confirmations. */
  compact?: boolean;
};

export const CancelPlanHelpText: React.FC<Props> = ({
  subscriptionDetails,
  clientFlags,
  userEmail,
  featureEnabled,
  compact,
}) => {
  const billing = useContext(BillingContext);
  const showSelfServe =
    billing?.isManager &&
    ableToSelfCancel({
      subscriptionDetails,
      clientFlags,
      userEmail,
      featureEnabled,
    });

  if (showSelfServe) {
    return (
      <span>
        {compact ? "To cancel instead," : "To cancel your plan, please"}{" "}
        <Button
          type="link"
          noPadding
          onClick={() => {
            billing?.setContactSupportInfoBox(undefined);
            billing?.openSelfServeCancelModal?.();
          }}
          style={{
            display: "inline-flex",
            verticalAlign: "baseline",
            height: "auto",
            lineHeight: "inherit",
            fontWeight: 500,
            color: COLORS.coeblue4,
          }}
        >
          click here
        </Button>
        .
      </span>
    );
  }

  return (
    <>
      {compact ? "To cancel instead, contact us at" : "To cancel your plan, please contact us at"}{" "}
      <a href="mailto:support@coefficient.io" target="_blank">
        support@coefficient.io
      </a>
      .
    </>
  );
};
